import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { publicRoutes } from "@/configs/routes/public-routes";
import PageLoader from "@/components/template/PageLoader";
import PublicRoute from "@/components/layouts/PublicRoute";
import { PATHS } from "@/constants/page-paths";
import LoginRoute from "@/components/layouts/LoginRoute";

const AllRoutes = () => {
  return (
    <Routes>
      <Route element={<LoginRoute />}>
        <Route path={PATHS.LOGIN} element={
          <Suspense fallback={<PageLoader />}>
            {(() => {
              const LoginComponent = publicRoutes.find(route => route.path === PATHS.LOGIN)?.component;
              return LoginComponent ? <LoginComponent /> : null;
            })()}
          </Suspense>
        } />
      </Route>
      <Route element={<PublicRoute />}>
        {publicRoutes?.filter(route => route.path !== PATHS.LOGIN).map((route) => (
          <Route
            key={route.routeKey}
            path={route.path}
            element={
              <Suspense fallback={<PageLoader />}>
                <route.component />
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route path="*" element={<Navigate to={PATHS.LOGIN} />} />
    </Routes>
  );
};

const Pages = () => {
  return (
    <>
        <AllRoutes />
    </>
  );
};

export default Pages;
